import React from 'react'
import LayoutAdmin from '../../Components/LayoutAdmin/LayoutAdmin'
import ToolCard from '../../Components/AdminTestPanelComponents/ToolCard'
import LoginAsClientTool from '../../Components/AdminTestPanelComponents/LoginAsClientTool'
import { TestTube2, AlertTriangle, PackagePlus } from 'lucide-react' // Import icons for your tools
import CommandeCreationTool from '../../Components/AdminTestPanelComponents/CreateTestCommandeTool'

const AdminTestPanel = () => {
	const styles = {
		panelContainer: {
			padding: '2rem',
			fontFamily: 'Montserrat, sans-serif',
		},
		header: {
			marginBottom: '2rem',
		},
		title: {
			fontSize: '2rem',
			fontWeight: 700,
			color: '#111827',
			margin: '0 0 0.5rem 0',
		},
		subtitle: {
			fontSize: '1rem',
			color: '#4b5563',
			margin: 0,
			maxWidth: '60ch',
		},
		toolsGrid: {
			display: 'grid',
			gap: '1.5rem',
		},
	}

	return (
		<LayoutAdmin>
			<div style={styles.panelContainer}>
				<div style={styles.header}>
					<h1 style={styles.title}>Admin & QA Testing Panel</h1>
					<p style={styles.subtitle}>
						A collection of internal tools to test and verify
						application functionality. Each tool is isolated and
						will not affect your session.
					</p>
				</div>

				<div style={styles.toolsGrid}>
					{/* --- Login Tester Tool --- */}
					<ToolCard
						title='Login API Tester'
						description='Verify user credentials against the login API endpoint without redirecting or setting state.'
						icon={<TestTube2 size={24} color='#3b82f6' />}
						defaultOpen={true} // Have the first tool open by default
					>
						<LoginAsClientTool />
					</ToolCard>

					{/* --- NEW: Commande Creation Tool --- */}
					<ToolCard
						title='Commande Creation Tester'
						description="Sends a pre-defined 'mise-a-disposition' commande to the API."
						icon={<PackagePlus size={24} color='#16a34a' />}
					>
						<CommandeCreationTool />
					</ToolCard>

					{/* --- EXAMPLE: How you would add a future tool --- */}
					<ToolCard
						title='Feature Flag Toggler'
						description='Enable or disable experimental features for your current session.'
						icon={<AlertTriangle size={24} color='#f59e0b' />}
					>
						{/* You would put your new tool component here */}
						<p style={{ color: '#6b7280' }}>
							Feature Flag Tool content goes here...
						</p>
					</ToolCard>

					{/* Add more ToolCards here as you build more tools */}
				</div>
			</div>
		</LayoutAdmin>
	)
}

export default AdminTestPanel
